export default {
  getUserApps(state) {
    return state.applications
  },
}
